import { convertFromRaw } from "draft-js";
import Hero from "./components/Hero/Hero";
import Content from "./components/Content/Content";
import Tabs from "./components/Tabs/Tabs";
import Footer from "../../components/Footer/Footer";
import Newsletter from "../../components/Footer/components/Newsletter/Newsletter";
import { JobListing } from "../../../common/types";
import OpenPositions from "./components/OpenPositions/OpenPositions";
import Utisci from "./components/Utisci/Utisci";
import BezUtisaka from "./components/BezUtisaka/BezUtisaka";
import { returnUtisci } from "../../../pages/api/utisak/get";
import { CompaniesSingleResponse } from "../../../pages/api/company";
import { returnIntervjui } from "../../../pages/api/intervju/get";
import { returnOdgovori } from "../../../pages/api/utisak/get-odgovor";
import Plate from "./components/Plate/Plate";
import { Plate as PlateType } from "../../../pages/api/plata/get";

type activeTabState =
    | "o-kompaniji"
    | "otvorene-pozicije"
    | "iskustva"
    | "intervjui"
    | "plate";

type KompanijaProps = {
    data: CompaniesSingleResponse;
    companyJobs?: JobListing[];
    utisci?: returnUtisci[];
    odgovori?: returnOdgovori[];
    intervjui?: returnIntervjui[];
    plate?: PlateType[];
    type: activeTabState;
};

export default function Kompanija({
    data,
    companyJobs,
    utisci,
    odgovori,
    intervjui,
    plate,
    type,
}: KompanijaProps) {
    const premiumBodyNotEmpty =
        JSON.parse(data.bodyPremium) &&
        convertFromRaw(JSON.parse(data.bodyPremium)).hasText();

    const premiumBodyMobileNotEmpty =
        JSON.parse(data.bodyPremiumMobile) &&
        convertFromRaw(JSON.parse(data.bodyPremiumMobile)).hasText();

    return (
        <div className="relative bg-white">
            <Hero
                title={data.name}
                slug={data.slug}
                logo={data.logo}
                excerpt={data.excerpt}
                size={data.size}
                city={data.companies_cities}
                link={data.meta.website}
                premium={data.plan === "PREMIUM"}
            />
            <Tabs activeTab={type} slug={data.slug} />
            {type === "o-kompaniji" && (
                <div className="relative mb-20 max-w-screen-lg mx-auto py-6 md:px-6 bg-white">
                    <div className="hidden md:block">
                        <Content
                            content={
                                premiumBodyNotEmpty && data.plan === "PREMIUM"
                                    ? data.bodyPremium
                                    : data.body
                            }
                        />
                    </div>
                    <div className="md:hidden">
                        <Content
                            content={
                                premiumBodyMobileNotEmpty &&
                                data.plan === "PREMIUM"
                                    ? data.bodyPremiumMobile
                                    : data.body
                            }
                        />
                    </div>
                </div>
            )}
            {type === "otvorene-pozicije" && (
                <OpenPositions companyJobs={companyJobs} />
            )}
            {type === "iskustva" && (
                <div className="relative mb-20 max-w-screen-lg mx-auto p-6 bg-white">
                    <div className="w-full bg-blue-superlight rounded mb-8 py-6 max-w-screen-md m-auto px-6 text-center">
                        Zbog ograničenog vremena za moderaciju, odlučili smo
                        ukinuti sekciju "Utisci". <br />
                        Preporučujemo da, ukoliko želite saznati više o
                        kompaniji, posjetite Reddit grupu "ITPoslodavci" i
                        postavite svoja pitanja direktno u toj zajednici. Klikni{" "}
                        <a href="https://www.reddit.com/r/ITPoslodavci/">
                            ovdje
                        </a>{" "}
                        da odeš na grupu. <br /> Uskoro ćemo staviti dzobs na
                        public repo pa će svako imati mogucnost unaprijedjenja
                        platforme. <br /> Možda pronadjemo neko rjesenje za
                        recenzije.
                    </div>
                </div>
            )}
            {type === "plate" && (
                <div className="relative mb-20 max-w-screen-lg mx-auto p-6 bg-white">
                    <Plate
                        companyId={data.id}
                        slug={data.slug}
                        name={data.name}
                        plate={plate}
                    />
                </div>
            )}
            <Newsletter bg="bg-gray-light" />
            <Footer />
        </div>
    );
}
